class MemoComment {
  id: string;
  memberId: number;
  text: string = '';
  hasBinary: boolean;
  binaryName: string;
  binaryContentType: string;
  binary: string = '';
  binaryRaw: string = '';
  created: number;
  callout: boolean;
  notifiedMembersId: number[];
}

export default MemoComment;



// WEBPACK FOOTER //
// ./src/entities/MemoComment.ts